"use client";

import clsx from "clsx";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { memo } from "react";
import CalendarRangeContent from "./CalendarRangeContent";
import CalendarSingleContent from "./CalendarSingleContent";

const TripDatePickerContent = memo(
  ({
    mode = "range", // range | single
    activeTab,
    setActiveTab,
    value,
    handleDateSelect,
    defaultMonth,
    getPriceByDate,
    currency,
    isRoundTrip,
    mobileDepartureClick,
    isFromDate,
    departureDate,
    mobileReturnClick,
    returnDate,
    isMultiCity,
    disabled,
    publicHolidays,
    translationNamespace = "common",
    dayButtonComponent,
    getDayMeta,
    wrapperClassName,
  }) => {
    // Keep structure identical to original DatePickerContent but without flexible tab
    const t = useTranslationDetector(translationNamespace);

    return (
      <div className={clsx("flex h-[calc(100%-83px)] w-full flex-col", wrapperClassName)}>
        {/* Calendar Tab Content - generic always calendar */}
        {mode === "range" ? (
          <CalendarRangeContent
            value={value}
            handleDateSelect={handleDateSelect}
            defaultMonth={defaultMonth}
            getPriceByDate={getPriceByDate}
            currency={currency}
            isRoundTrip={isRoundTrip}
            mobileDepartureClick={mobileDepartureClick}
            isFromDate={isFromDate}
            departureDate={departureDate}
            mobileReturnClick={mobileReturnClick}
            returnDate={returnDate}
            isMultiCity={isMultiCity}
            publicHolidays={publicHolidays}
            dayButtonComponent={dayButtonComponent}
            getDayMeta={getDayMeta}
          />
        ) : (
          <CalendarSingleContent
            value={value}
            handleDateSelect={handleDateSelect}
            defaultMonth={defaultMonth}
            getPriceByDate={getPriceByDate}
            currency={currency}
            isRoundTrip={isRoundTrip}
            mobileDepartureClick={mobileDepartureClick}
            isFromDate={isFromDate}
            departureDate={departureDate}
            mobileReturnClick={mobileReturnClick}
            returnDate={returnDate}
            isMultiCity={isMultiCity}
            disabled={disabled}
            publicHolidays={publicHolidays}
            dayButtonComponent={dayButtonComponent}
            getDayMeta={getDayMeta}
          />
        )}
      </div>
    );
  },
);

TripDatePickerContent.displayName = "TripDatePickerContent";

export default TripDatePickerContent;


